<template>
  <section
    class="<lg:my-4 <lg:-mx-4"
    :class="{ 'lg:hidden': $feature.pdpShopTheLookThreshold && (productSetLength < productSetThreshold) }"
    data-scroll-el="shopTheLook"
  >
    <vf-carousel-elevate
      v-if="product?.productSets?.length"
      class-container="gap-x-1"
      class-controls="<lg:hidden h-10 w-10 bg-brand-1/50 p-2 c-white shadow-sm @hactive:bg-brand-1/90"
      :show-arrows="product.productSets.length > 3"
      size-controls="md"
    >
      <base-button
        v-for="productSet in product.productSets"
        :key="productSet.productSetId"
        v-style:w="{
          sm: product.productSets.length === 1 ? '100%' : '90%',
          lg: product.productSets.length > 3 ? '29.58%' : `${100 / product.productSets.length}%`,
        }"
        class="relative"
        @click="openShopTheLook(productSet)"
      >
        <base-picture
          :alt="productSet.description"
          class="w-full"
          :height="gallery.presets.src.height"
          :src="getImageTransformations(productSet.images[0], gallery.presets.src)"
          :width="gallery.presets.src.width"
        />
        <div class="absolute left-0 top-0 z-3 flex items-center gap-x-1 px-3 py-4">
          <p class="underscored">
            {{ productSet.text || $t.shopTheLookTileCta }}
          </p>
          <vf-icon name="plus" size="sm" />
        </div>
      </base-button>
    </vf-carousel-elevate>
  </section>
</template>

<script setup lang="ts">
const { gallery, shopTheLook } = useAppConfig().pages?.pdp || {}
const { openShopTheLook, product } = usePdp()

const productSetLength = computed(() => product.value?.productSets?.length || 0)
const productSetThreshold = shopTheLook?.productSetThreshold || 0
</script>
